module.exports = __webpack_public_path__ + "img/Misc_Diamond.6b3476b1.svg";